




















































































































import "./project-board.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, generateItems } from "./helpers";
import AttachmentEditor from "../goals/attachment-editor.vue";
import DueDateSetup from "./due-date-setup.vue";
import CardMembers from "./card-members.vue";
import ListCard from "./list-card.vue";
import VideoPlayer from "../video-player/video-player.vue";
import ResizableTextarea from "../common/ResizableTextarea.js";
import moment from "moment";
import Modal from "../common/confirm.js";

let board = {
  children: [],
};

export default Vue.extend({
  name: "project-calendar",
  components: { Container, Draggable, AttachmentEditor, DueDateSetup, CardMembers, ListCard, VideoPlayer, ResizableTextarea },
  props: {
    id: String,
  },
  data() {
    return {
      isLoading: false,
      addList: false,
      newListTitle: null,
      board,
      upperDropPlaceholderOptions: {
        className: "cards-drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      showDueDateEditor: false,
      showCardMembers: false,
      showAttachmentEditor: false,
      showCardEditor: false,
      edittingCard: null,
      edittingCardColumn: null,
      edittingCardTitle: null,
      edittingCardAttachments: [],
      cardEditorStyles: {},
      attachmentEditorStyles: {},
      disableAttachmentEdit: false,
      showVideoPlayer: false,
      videoUrl: "",
      showDatePicker: false,
      currentDay: new Date(),
      calendarViewType: "week",
    };
  },
  computed: {
    boardModel(): any {
      return this.board.children.map((column) => {
        return {
          id: column.id,
          name: column.name,
          children: column.children.map((card) => {
            return {
              id: card.id,
              title: card.title,
              dueDateSetting: card.dueDateSetting,
              selectedMemberIds: card.selectedMemberIds ? card.selectedMemberIds : [],
              attachments: card.attachments,
            };
          }),
        };
      });
    },
    cards(): any {
      let context = this as any;
      let result = [];

      context.board.children.forEach((column) => {
        let cards = column.children
          .filter((card) => card.dueDateSetting && card.dueDateSetting.dueDate)
          .map((card) => {
            return {
              id: card.id,
              title: card.title,
              dueDateSetting: card.dueDateSetting,
              selectedMemberIds: card.selectedMemberIds ? card.selectedMemberIds : [],
              attachments: card.attachments,
              cardData: card,
              columnData: column,
            };
          });
        result = result.concat(cards);
      });

      return result;
    },
    currentDayIsToday() {
      let context = this as any;
      return context.isToday(context.currentDay);
    },
    currentPeriodTitle() {
      let context = this as any;
      if (context.calendarViewType === "week") {
        return `${moment(context.currentDay).startOf("week").format("MMM DD")} - ${moment(context.currentDay).endOf("week").format("MMM DD")}`;
      } else {
        return moment(context.currentDay).format("MMM DD, YYYY");
      }
    },
    days() {
      let context = this as any;
      if (context.calendarViewType === "week") {
        let weekDay = moment(context.currentDay).startOf("week").format("YYYY-MM-DD");
        return [0, 1, 2, 3, 4, 5, 6].map((i) => {
          let date = moment(weekDay).add(i, "day");
          return {
            date: date.toDate(),
            today: context.isToday(date.toDate()),
            title: date.format("ddd, MMM DD"),
            cards: context.cards.filter((card) => date.format("YYYY-MM-DD") === moment(card.dueDateSetting.dueDate).format("YYYY-MM-DD")),
          };
        });
      } else {
        return [
          {
            date: context.currentDay,
            today: context.isToday(context.currentDay),
            title: moment(context.currentDay).format("ddd, MMM DD"),
            cards: context.cards.filter((card) => moment(context.currentDay).format("YYYY-MM-DD") === moment(card.dueDateSetting.dueDate).format("YYYY-MM-DD")),
          },
        ];
      }
    },
    ...mapState("project", ["currentProject"]),
    ...mapGetters("project", ["canEditCurrentProject"]),
  },
  mounted() {
    this.$Notice.config({
      top: 50,
      duration: 2,
    });

    this.loadBoard();

    let context = this;
    abp.event.on("abp.notifications.received", this.handleNotificationReceived);
  },
  beforeDestroy() {
    console.log("leave page");
    abp.event.off("abp.notifications.received", this.handleNotificationReceived);
  },
  watch: {
    boardModel: {
      handler: function () {
        if (this.isLoading === true) {
          return;
        }

        let currentProject = (this as any).currentProject;
        let projectBoard = {
          boardData: JSON.stringify(this.boardModel),
          boardDataVersion: currentProject.boardDataVersion,
          id: currentProject.id,
        };

        if (projectBoard.boardData != currentProject.boardData) {
          this.$store
            .dispatch("project/updateBoardData", { data: projectBoard })
            .then((response) => {
              this.$Notice.success({
                title: "Save",
                desc: "Success! ",
              });
            })
            .catch((error) => {
              if (error.response.status === 403) {
                this.loadBoardData();
              }
            });
        }
      },
      deep: true,
    },
    currentProject() {
      let context = this as any;
      context.loadBoardData();
    },
  },
  methods: {
    loadBoard() {
      this.$store.dispatch("project/get", { id: this.id }).then((response) => {});
    },
    loadBoardData() {
      let context = this as any;
      let boardData = context.currentProject.boardData;
      let columns = [];
      if (boardData !== null && boardData !== "") {
        columns = JSON.parse(boardData);
      }

      this.isLoading = true;
      this.board.children = columns.map((column) => {
        return {
          id: column.id,
          name: column.name,
          addCard: false,
          newCardTitle: "",
          children: column.children,
        };
      });

      setTimeout(function () {
        context.isLoading = false;
      }, 100);
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentProject.boardDataVersion) {
        this.loadBoard();
      }
    },
    gotoToday() {
      return (this.currentDay = new Date());
    },
    prevPeriod() {
      let offset = this.calendarViewType === "week" ? 7 : 1;
      this.currentDay = moment(this.currentDay).add(-offset, "day").toDate();
    },
    nextPeriod() {
      let offset = this.calendarViewType === "week" ? 7 : 1;
      this.currentDay = moment(this.currentDay).add(offset, "day").toDate();
    },
    datePickerChangeHandler(date) {
      this.currentDay = date;
    },
    handleNewList() {
      this.addList = true;
      this.newListTitle = "";
    },
    handleSaveNewList() {
      this.board.children.push({
        id: this.uuid(),
        name: this.newListTitle,
        addCard: false,
        newCardTitle: "",
        children: [],
      });
      this.addList = false;
    },
    handleCardActionClick(card, column, e) {
      if (!card.attachments) {
        card.attachments = [];
      }
      this.edittingCard = card;
      this.edittingCardColumn = column;
      this.edittingCardTitle = card.title;
      this.edittingCardAttachments = card.attachments.map((attachment) => Object.assign({ test: "" }, attachment));
      this.getCardEditorPosition(e.target.parentElement);
      this.showCardEditor = true;
    },
    handleSaveCard() {
      if (this.edittingCardTitle && this.edittingCardTitle != "") {
        this.edittingCard.title = this.edittingCardTitle;
      }

      this.showCardEditor = false;
    },
    handleSaveAttachment() {
      this.edittingCard.attachments = this.edittingCardAttachments;
      this.showAttachmentEditor = false;
      this.showCardEditor = false;
    },
    handleShowCardMembers() {
      this.showCardMembers = true;
    },
    handleCardMembersSave(selectedMemberIds, event) {
      this.edittingCard.selectedMemberIds = selectedMemberIds;
      this.showCardMembers = false;
      this.showCardEditor = false;
    },
    handleDeleteCard() {
      for (var i = 0; i < this.edittingCardColumn.children.length; i++) {
        if (this.edittingCardColumn.children[i] === this.edittingCard) {
          this.edittingCardColumn.children.splice(i, 1);
        }
      }
      this.showCardEditor = false;
    },
    handleCopyCard() {
      for (var i = 0; i < this.edittingCardColumn.children.length; i++) {
        if (this.edittingCardColumn.children[i] === this.edittingCard) {
          let newCard = Object.assign({}, this.edittingCard);
          newCard = Object.assign(newCard, { id: this.uuid() });
          this.edittingCardColumn.children.splice(i, 0, newCard);
          break;
        }
      }
      this.showCardEditor = false;
    },
    handleAttachToCard() {
      this.showAttachmentEditor = true;
    },
    handleAddAttachment() {
      this.edittingCardAttachments.push({
        link: null,
        title: "",
        type: null,
        status: "new",
      });
    },
    handleAttachmentEditting() {
      this.disableAttachmentEdit = true;
    },
    handleAttachmentEdittingEnd() {
      this.disableAttachmentEdit = false;
    },
    handleAttachmentCancelNew() {
      if (this.edittingCardAttachments.length > 0 && this.edittingCardAttachments[this.edittingCardAttachments.length - 1]) {
        this.edittingCardAttachments.pop();
      }
    },
    handleAttachmentRemove(attachment) {
      this.edittingCardAttachments = this.edittingCardAttachments.filter((a) => {
        return a.link !== attachment.link;
      });
    },
    handleVideoClick(type, url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
    },
    handleAddDueDate() {
      this.showDueDateEditor = true;
    },
    handleDueDateSave(card) {
      this.showDueDateEditor = false;
      this.showCardEditor = false;
      this.edittingCard.dueDateSetting = Object.assign({}, card);
    },
    getCardEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        // if ((" " + element.className + " ").indexOf(" card-scene ") > -1) {
        //   break;
        // }

        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.cardEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };

      this.attachmentEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    onColumnDrop(dropResult) {
      let board = Object.assign({}, this.board);
      board.children = applyDrag(board.children, dropResult);
      this.board = board;
    },
    onCardDrop(columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        let board = Object.assign({}, this.board);
        let column = board.children.filter((p) => p.id === columnId)[0];
        let columnIndex = board.children.indexOf(column);
        let newColumn = Object.assign({}, column);
        newColumn.children = applyDrag(newColumn.children, dropResult);
        board.children.splice(columnIndex, 1, newColumn);
        this.board = board;
      }
    },
    getCardPayload(columnId) {
      return (index) => {
        return this.board.children.filter((p) => p.id === columnId)[0].children[index];
      };
    },
    getGhostParent() {
      return document.body;
    },
    dragStart() {
      console.log("drag started");
    },
    log(...params) {
      console.log(...params);
    },
    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
    isToday(date) {
      return moment(date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");
    },
  },
});
